// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/envelope/v1/envelope.proto" (package "agency.envelope.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Message } from "../../session/v1/session";
import { SessionForkedEvent } from "../../events/v1/events";
import { ActorSpawnFailedEvent } from "../../events/v1/events";
import { ModelCircuitBreakerStateChange } from "../../events/v1/events";
import { SessionEndedEvent } from "../../events/v1/events";
import { SessionStartedEvent } from "../../events/v1/events";
import { LLMCallEnd } from "../../events/v1/events";
import { LLMCallStart } from "../../events/v1/events";
import { TenantContextEvent } from "../../events/v1/events";
import { SnapshotEvent } from "../../events/v1/events";
import { SkillExecutionEvent } from "../../events/v1/events";
import { DLQAlertEvent } from "../../events/v1/events";
import { ModelFallbackEvent } from "../../events/v1/events";
import { RequestFailedEvent } from "../../events/v1/events";
import { ToolRejectionEvent } from "../../events/v1/events";
import { HarnessShutdownEvent } from "../../events/v1/events";
import { HarnessReadyEvent } from "../../events/v1/events";
import { QuotaExhaustedEvent } from "../../quota/v1/quota";
import { RateLimitedEvent } from "../../events/v1/events";
import { ToolCallFrequencyExceededEvent } from "../../events/v1/events";
import { ArtifactInvalidationEvent } from "../../events/v1/events";
import { ArtifactUpdated } from "../../events/v1/events";
import { ContextReady } from "../../events/v1/events";
import { ContextUpdated } from "../../events/v1/events";
import { ToolResult } from "../../tool/v1/tool";
import { ToolCall } from "../../tool/v1/tool";
import { ToolExecutionEnd } from "../../events/v1/events";
import { ToolExecutionUpdate } from "../../events/v1/events";
import { ToolExecutionStart } from "../../events/v1/events";
import { MessageEnd } from "../../events/v1/events";
import { AssistantMessageDelta } from "../../events/v1/events";
import { MessageUpdate } from "../../events/v1/events";
import { MessageStart } from "../../events/v1/events";
import { TurnEnd } from "../../events/v1/events";
import { TurnStart } from "../../events/v1/events";
import { InterruptEvent } from "../../events/v1/events";
import { CancelledEvent } from "../../events/v1/events";
import { SessionStartFailedEvent } from "../../events/v1/events";
import { SessionFailedEvent } from "../../events/v1/events";
import { AgentDoneEvent } from "../../events/v1/events";
import { StepEvent } from "../../events/v1/events";
import { PlanEvent } from "../../events/v1/events";
import { Claims } from "../../auth/v1/auth";
/**
 * TraceContext carries OpenTelemetry trace propagation data.
 *
 * @generated from protobuf message agency.envelope.v1.TraceContext
 */
export interface TraceContext {
    /**
     * trace_id is the W3C trace ID (32 hex chars).
     *
     * @generated from protobuf field: string trace_id = 1
     */
    traceId: string;
    /**
     * span_id is the W3C span ID (16 hex chars).
     *
     * @generated from protobuf field: string span_id = 2
     */
    spanId: string;
    /**
     * trace_flags are W3C trace flags (8-bit field).
     *
     * @generated from protobuf field: uint32 trace_flags = 3
     */
    traceFlags: number;
    /**
     * parent_span_id is the parent span ID (16 hex chars, optional).
     *
     * @generated from protobuf field: string parent_span_id = 4
     */
    parentSpanId: string;
    /**
     * baggage contains additional trace context key-value pairs.
     *
     * @generated from protobuf field: map<string, string> baggage = 5
     */
    baggage: {
        [key: string]: string;
    };
}
/**
 * Envelope wraps outbound session-events traffic with authentication, tracing, and versioning.
 * Every message on session-events MUST be wrapped in an Envelope.
 * For inbound user messages use IngressEnvelope.
 *
 * @generated from protobuf message agency.envelope.v1.Envelope
 */
export interface Envelope {
    /**
     * claims provides authentication and authorization context.
     * REQUIRED: Every message must be authenticated at unwrap.
     *
     * @generated from protobuf field: agency.auth.v1.Claims claims = 1
     */
    claims?: Claims;
    /**
     * trace_context carries OpenTelemetry propagation data.
     *
     * @generated from protobuf field: agency.envelope.v1.TraceContext trace_context = 2
     */
    traceContext?: TraceContext;
    /**
     * harness_version enables schema migrations during rolling upgrades.
     *
     * @generated from protobuf field: uint32 harness_version = 3
     */
    harnessVersion: number;
    /**
     * payload is the concrete outbound session event — exactly one arm must be set.
     *
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "planEvent";
        /**
         * Session lifecycle
         *
         * @generated from protobuf field: agency.events.v1.PlanEvent plan_event = 10
         */
        planEvent: PlanEvent;
    } | {
        oneofKind: "stepEvent";
        /**
         * @generated from protobuf field: agency.events.v1.StepEvent step_event = 11
         */
        stepEvent: StepEvent;
    } | {
        oneofKind: "agentDoneEvent";
        /**
         * @generated from protobuf field: agency.events.v1.AgentDoneEvent agent_done_event = 12
         */
        agentDoneEvent: AgentDoneEvent;
    } | {
        oneofKind: "sessionFailedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SessionFailedEvent session_failed_event = 13
         */
        sessionFailedEvent: SessionFailedEvent;
    } | {
        oneofKind: "sessionStartFailedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SessionStartFailedEvent session_start_failed_event = 14
         */
        sessionStartFailedEvent: SessionStartFailedEvent;
    } | {
        oneofKind: "cancelledEvent";
        /**
         * @generated from protobuf field: agency.events.v1.CancelledEvent cancelled_event = 15
         */
        cancelledEvent: CancelledEvent;
    } | {
        oneofKind: "interruptEvent";
        /**
         * @generated from protobuf field: agency.events.v1.InterruptEvent interrupt_event = 16
         */
        interruptEvent: InterruptEvent;
    } | {
        oneofKind: "turnStart";
        /**
         * Turn / message streaming
         *
         * @generated from protobuf field: agency.events.v1.TurnStart turn_start = 20
         */
        turnStart: TurnStart;
    } | {
        oneofKind: "turnEnd";
        /**
         * @generated from protobuf field: agency.events.v1.TurnEnd turn_end = 21
         */
        turnEnd: TurnEnd;
    } | {
        oneofKind: "messageStart";
        /**
         * @generated from protobuf field: agency.events.v1.MessageStart message_start = 22
         */
        messageStart: MessageStart;
    } | {
        oneofKind: "messageUpdate";
        /**
         * @generated from protobuf field: agency.events.v1.MessageUpdate message_update = 23
         */
        messageUpdate: MessageUpdate;
    } | {
        oneofKind: "assistantMessageDelta";
        /**
         * @generated from protobuf field: agency.events.v1.AssistantMessageDelta assistant_message_delta = 24
         */
        assistantMessageDelta: AssistantMessageDelta;
    } | {
        oneofKind: "messageEnd";
        /**
         * @generated from protobuf field: agency.events.v1.MessageEnd message_end = 25
         */
        messageEnd: MessageEnd;
    } | {
        oneofKind: "toolExecutionStart";
        /**
         * Tool execution
         *
         * @generated from protobuf field: agency.events.v1.ToolExecutionStart tool_execution_start = 30
         */
        toolExecutionStart: ToolExecutionStart;
    } | {
        oneofKind: "toolExecutionUpdate";
        /**
         * @generated from protobuf field: agency.events.v1.ToolExecutionUpdate tool_execution_update = 31
         */
        toolExecutionUpdate: ToolExecutionUpdate;
    } | {
        oneofKind: "toolExecutionEnd";
        /**
         * @generated from protobuf field: agency.events.v1.ToolExecutionEnd tool_execution_end = 32
         */
        toolExecutionEnd: ToolExecutionEnd;
    } | {
        oneofKind: "toolCall";
        /**
         * @generated from protobuf field: agency.tool.v1.ToolCall tool_call = 33
         */
        toolCall: ToolCall;
    } | {
        oneofKind: "toolResult";
        /**
         * @generated from protobuf field: agency.tool.v1.ToolResult tool_result = 34
         */
        toolResult: ToolResult;
    } | {
        oneofKind: "contextUpdated";
        /**
         * Context / artifacts
         *
         * @generated from protobuf field: agency.events.v1.ContextUpdated context_updated = 40
         */
        contextUpdated: ContextUpdated;
    } | {
        oneofKind: "contextReady";
        /**
         * @generated from protobuf field: agency.events.v1.ContextReady context_ready = 41
         */
        contextReady: ContextReady;
    } | {
        oneofKind: "artifactUpdated";
        /**
         * @generated from protobuf field: agency.events.v1.ArtifactUpdated artifact_updated = 42
         */
        artifactUpdated: ArtifactUpdated;
    } | {
        oneofKind: "artifactInvalidationEvent";
        /**
         * @generated from protobuf field: agency.events.v1.ArtifactInvalidationEvent artifact_invalidation_event = 43
         */
        artifactInvalidationEvent: ArtifactInvalidationEvent;
    } | {
        oneofKind: "toolCallFrequencyExceededEvent";
        /**
         * Quota / rate limiting
         *
         * @generated from protobuf field: agency.events.v1.ToolCallFrequencyExceededEvent tool_call_frequency_exceeded_event = 50
         */
        toolCallFrequencyExceededEvent: ToolCallFrequencyExceededEvent;
    } | {
        oneofKind: "rateLimitedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.RateLimitedEvent rate_limited_event = 51
         */
        rateLimitedEvent: RateLimitedEvent;
    } | {
        oneofKind: "quotaExhaustedEvent";
        /**
         * @generated from protobuf field: agency.quota.v1.QuotaExhaustedEvent quota_exhausted_event = 52
         */
        quotaExhaustedEvent: QuotaExhaustedEvent;
    } | {
        oneofKind: "harnessReadyEvent";
        /**
         * Harness lifecycle
         *
         * @generated from protobuf field: agency.events.v1.HarnessReadyEvent harness_ready_event = 60
         */
        harnessReadyEvent: HarnessReadyEvent;
    } | {
        oneofKind: "harnessShutdownEvent";
        /**
         * @generated from protobuf field: agency.events.v1.HarnessShutdownEvent harness_shutdown_event = 61
         */
        harnessShutdownEvent: HarnessShutdownEvent;
    } | {
        oneofKind: "toolRejectionEvent";
        /**
         * Errors / alerts
         *
         * @generated from protobuf field: agency.events.v1.ToolRejectionEvent tool_rejection_event = 70
         */
        toolRejectionEvent: ToolRejectionEvent;
    } | {
        oneofKind: "requestFailedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.RequestFailedEvent request_failed_event = 71
         */
        requestFailedEvent: RequestFailedEvent;
    } | {
        oneofKind: "modelFallbackEvent";
        /**
         * @generated from protobuf field: agency.events.v1.ModelFallbackEvent model_fallback_event = 72
         */
        modelFallbackEvent: ModelFallbackEvent;
    } | {
        oneofKind: "dlqAlertEvent";
        /**
         * @generated from protobuf field: agency.events.v1.DLQAlertEvent dlq_alert_event = 73
         */
        dlqAlertEvent: DLQAlertEvent;
    } | {
        oneofKind: "skillExecutionEvent";
        /**
         * Other
         *
         * @generated from protobuf field: agency.events.v1.SkillExecutionEvent skill_execution_event = 80
         */
        skillExecutionEvent: SkillExecutionEvent;
    } | {
        oneofKind: "snapshotEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SnapshotEvent snapshot_event = 81
         */
        snapshotEvent: SnapshotEvent;
    } | {
        oneofKind: "tenantContextEvent";
        /**
         * @generated from protobuf field: agency.events.v1.TenantContextEvent tenant_context_event = 82
         */
        tenantContextEvent: TenantContextEvent;
    } | {
        oneofKind: "llmCallStart";
        /**
         * @generated from protobuf field: agency.events.v1.LLMCallStart llm_call_start = 83
         */
        llmCallStart: LLMCallStart;
    } | {
        oneofKind: "llmCallEnd";
        /**
         * @generated from protobuf field: agency.events.v1.LLMCallEnd llm_call_end = 84
         */
        llmCallEnd: LLMCallEnd;
    } | {
        oneofKind: "sessionStartedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SessionStartedEvent session_started_event = 85
         */
        sessionStartedEvent: SessionStartedEvent;
    } | {
        oneofKind: "sessionEndedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SessionEndedEvent session_ended_event = 86
         */
        sessionEndedEvent: SessionEndedEvent;
    } | {
        oneofKind: "modelCircuitBreakerStateChange";
        /**
         * @generated from protobuf field: agency.events.v1.ModelCircuitBreakerStateChange model_circuit_breaker_state_change = 87
         */
        modelCircuitBreakerStateChange: ModelCircuitBreakerStateChange;
    } | {
        oneofKind: "actorSpawnFailedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.ActorSpawnFailedEvent actor_spawn_failed_event = 88
         */
        actorSpawnFailedEvent: ActorSpawnFailedEvent;
    } | {
        oneofKind: "sessionForkedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SessionForkedEvent session_forked_event = 89
         */
        sessionForkedEvent: SessionForkedEvent;
    } | {
        oneofKind: undefined;
    };
    /**
     * nats_msg_id is the NATS message ID for idempotent publishing.
     * Format: <session>.<step>.<event-type>.<attempt>
     *
     * @generated from protobuf field: string nats_msg_id = 5
     */
    natsMsgId: string;
}
/**
 * IngressEnvelope wraps inbound user messages with authentication and tracing.
 * Published on ingress subjects and consumed by the session orchestrator.
 * For outbound session events use Envelope.
 *
 * @generated from protobuf message agency.envelope.v1.IngressEnvelope
 */
export interface IngressEnvelope {
    /**
     * claims provides authentication and authorization context.
     *
     * @generated from protobuf field: agency.auth.v1.Claims claims = 1
     */
    claims?: Claims;
    /**
     * trace_context carries OpenTelemetry propagation data.
     *
     * @generated from protobuf field: agency.envelope.v1.TraceContext trace_context = 2
     */
    traceContext?: TraceContext;
    /**
     * harness_version enables schema migrations during rolling upgrades.
     *
     * @generated from protobuf field: uint32 harness_version = 3
     */
    harnessVersion: number;
    /**
     * payload is the inbound user message.
     *
     * @generated from protobuf field: agency.session.v1.Message payload = 4
     */
    payload?: Message;
    /**
     * nats_msg_id is the NATS message ID for idempotent publishing.
     *
     * @generated from protobuf field: string nats_msg_id = 5
     */
    natsMsgId: string;
}
/**
 * EnvelopeUnwrapRequest requests envelope validation and unwrapping.
 *
 * @generated from protobuf message agency.envelope.v1.EnvelopeUnwrapRequest
 */
export interface EnvelopeUnwrapRequest {
    /**
     * envelope is the wrapped message to validate and unwrap.
     *
     * @generated from protobuf field: agency.envelope.v1.Envelope envelope = 1
     */
    envelope?: Envelope;
    /**
     * require_tenant restricts validation to a specific tenant (optional).
     *
     * @generated from protobuf field: string require_tenant = 2
     */
    requireTenant: string;
    /**
     * require_workspace restricts validation to a specific workspace (optional).
     *
     * @generated from protobuf field: string require_workspace = 3
     */
    requireWorkspace: string;
}
/**
 * EnvelopeUnwrapResponse returns the validation result and unwrapped payload.
 * payload mirrors Envelope.payload — the same oneof arms are present.
 *
 * @generated from protobuf message agency.envelope.v1.EnvelopeUnwrapResponse
 */
export interface EnvelopeUnwrapResponse {
    /**
     * validation_result is the validation outcome.
     *
     * @generated from protobuf field: agency.envelope.v1.EnvelopeValidationResult validation_result = 1
     */
    validationResult?: EnvelopeValidationResult;
    /**
     * payload is the unwrapped event (only if validation succeeded).
     * Arms match Envelope.payload exactly.
     *
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "planEvent";
        /**
         * @generated from protobuf field: agency.events.v1.PlanEvent plan_event = 10
         */
        planEvent: PlanEvent;
    } | {
        oneofKind: "stepEvent";
        /**
         * @generated from protobuf field: agency.events.v1.StepEvent step_event = 11
         */
        stepEvent: StepEvent;
    } | {
        oneofKind: "agentDoneEvent";
        /**
         * @generated from protobuf field: agency.events.v1.AgentDoneEvent agent_done_event = 12
         */
        agentDoneEvent: AgentDoneEvent;
    } | {
        oneofKind: "sessionFailedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SessionFailedEvent session_failed_event = 13
         */
        sessionFailedEvent: SessionFailedEvent;
    } | {
        oneofKind: "sessionStartFailedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SessionStartFailedEvent session_start_failed_event = 14
         */
        sessionStartFailedEvent: SessionStartFailedEvent;
    } | {
        oneofKind: "cancelledEvent";
        /**
         * @generated from protobuf field: agency.events.v1.CancelledEvent cancelled_event = 15
         */
        cancelledEvent: CancelledEvent;
    } | {
        oneofKind: "interruptEvent";
        /**
         * @generated from protobuf field: agency.events.v1.InterruptEvent interrupt_event = 16
         */
        interruptEvent: InterruptEvent;
    } | {
        oneofKind: "turnStart";
        /**
         * @generated from protobuf field: agency.events.v1.TurnStart turn_start = 20
         */
        turnStart: TurnStart;
    } | {
        oneofKind: "turnEnd";
        /**
         * @generated from protobuf field: agency.events.v1.TurnEnd turn_end = 21
         */
        turnEnd: TurnEnd;
    } | {
        oneofKind: "messageStart";
        /**
         * @generated from protobuf field: agency.events.v1.MessageStart message_start = 22
         */
        messageStart: MessageStart;
    } | {
        oneofKind: "messageUpdate";
        /**
         * @generated from protobuf field: agency.events.v1.MessageUpdate message_update = 23
         */
        messageUpdate: MessageUpdate;
    } | {
        oneofKind: "assistantMessageDelta";
        /**
         * @generated from protobuf field: agency.events.v1.AssistantMessageDelta assistant_message_delta = 24
         */
        assistantMessageDelta: AssistantMessageDelta;
    } | {
        oneofKind: "messageEnd";
        /**
         * @generated from protobuf field: agency.events.v1.MessageEnd message_end = 25
         */
        messageEnd: MessageEnd;
    } | {
        oneofKind: "toolExecutionStart";
        /**
         * @generated from protobuf field: agency.events.v1.ToolExecutionStart tool_execution_start = 30
         */
        toolExecutionStart: ToolExecutionStart;
    } | {
        oneofKind: "toolExecutionUpdate";
        /**
         * @generated from protobuf field: agency.events.v1.ToolExecutionUpdate tool_execution_update = 31
         */
        toolExecutionUpdate: ToolExecutionUpdate;
    } | {
        oneofKind: "toolExecutionEnd";
        /**
         * @generated from protobuf field: agency.events.v1.ToolExecutionEnd tool_execution_end = 32
         */
        toolExecutionEnd: ToolExecutionEnd;
    } | {
        oneofKind: "toolCall";
        /**
         * @generated from protobuf field: agency.tool.v1.ToolCall tool_call = 33
         */
        toolCall: ToolCall;
    } | {
        oneofKind: "toolResult";
        /**
         * @generated from protobuf field: agency.tool.v1.ToolResult tool_result = 34
         */
        toolResult: ToolResult;
    } | {
        oneofKind: "contextUpdated";
        /**
         * @generated from protobuf field: agency.events.v1.ContextUpdated context_updated = 40
         */
        contextUpdated: ContextUpdated;
    } | {
        oneofKind: "contextReady";
        /**
         * @generated from protobuf field: agency.events.v1.ContextReady context_ready = 41
         */
        contextReady: ContextReady;
    } | {
        oneofKind: "artifactUpdated";
        /**
         * @generated from protobuf field: agency.events.v1.ArtifactUpdated artifact_updated = 42
         */
        artifactUpdated: ArtifactUpdated;
    } | {
        oneofKind: "artifactInvalidationEvent";
        /**
         * @generated from protobuf field: agency.events.v1.ArtifactInvalidationEvent artifact_invalidation_event = 43
         */
        artifactInvalidationEvent: ArtifactInvalidationEvent;
    } | {
        oneofKind: "toolCallFrequencyExceededEvent";
        /**
         * @generated from protobuf field: agency.events.v1.ToolCallFrequencyExceededEvent tool_call_frequency_exceeded_event = 50
         */
        toolCallFrequencyExceededEvent: ToolCallFrequencyExceededEvent;
    } | {
        oneofKind: "rateLimitedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.RateLimitedEvent rate_limited_event = 51
         */
        rateLimitedEvent: RateLimitedEvent;
    } | {
        oneofKind: "quotaExhaustedEvent";
        /**
         * @generated from protobuf field: agency.quota.v1.QuotaExhaustedEvent quota_exhausted_event = 52
         */
        quotaExhaustedEvent: QuotaExhaustedEvent;
    } | {
        oneofKind: "harnessReadyEvent";
        /**
         * @generated from protobuf field: agency.events.v1.HarnessReadyEvent harness_ready_event = 60
         */
        harnessReadyEvent: HarnessReadyEvent;
    } | {
        oneofKind: "harnessShutdownEvent";
        /**
         * @generated from protobuf field: agency.events.v1.HarnessShutdownEvent harness_shutdown_event = 61
         */
        harnessShutdownEvent: HarnessShutdownEvent;
    } | {
        oneofKind: "toolRejectionEvent";
        /**
         * @generated from protobuf field: agency.events.v1.ToolRejectionEvent tool_rejection_event = 70
         */
        toolRejectionEvent: ToolRejectionEvent;
    } | {
        oneofKind: "requestFailedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.RequestFailedEvent request_failed_event = 71
         */
        requestFailedEvent: RequestFailedEvent;
    } | {
        oneofKind: "modelFallbackEvent";
        /**
         * @generated from protobuf field: agency.events.v1.ModelFallbackEvent model_fallback_event = 72
         */
        modelFallbackEvent: ModelFallbackEvent;
    } | {
        oneofKind: "dlqAlertEvent";
        /**
         * @generated from protobuf field: agency.events.v1.DLQAlertEvent dlq_alert_event = 73
         */
        dlqAlertEvent: DLQAlertEvent;
    } | {
        oneofKind: "skillExecutionEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SkillExecutionEvent skill_execution_event = 80
         */
        skillExecutionEvent: SkillExecutionEvent;
    } | {
        oneofKind: "snapshotEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SnapshotEvent snapshot_event = 81
         */
        snapshotEvent: SnapshotEvent;
    } | {
        oneofKind: "tenantContextEvent";
        /**
         * @generated from protobuf field: agency.events.v1.TenantContextEvent tenant_context_event = 82
         */
        tenantContextEvent: TenantContextEvent;
    } | {
        oneofKind: "llmCallStart";
        /**
         * @generated from protobuf field: agency.events.v1.LLMCallStart llm_call_start = 83
         */
        llmCallStart: LLMCallStart;
    } | {
        oneofKind: "llmCallEnd";
        /**
         * @generated from protobuf field: agency.events.v1.LLMCallEnd llm_call_end = 84
         */
        llmCallEnd: LLMCallEnd;
    } | {
        oneofKind: "sessionStartedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SessionStartedEvent session_started_event = 85
         */
        sessionStartedEvent: SessionStartedEvent;
    } | {
        oneofKind: "sessionEndedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SessionEndedEvent session_ended_event = 86
         */
        sessionEndedEvent: SessionEndedEvent;
    } | {
        oneofKind: "modelCircuitBreakerStateChange";
        /**
         * @generated from protobuf field: agency.events.v1.ModelCircuitBreakerStateChange model_circuit_breaker_state_change = 87
         */
        modelCircuitBreakerStateChange: ModelCircuitBreakerStateChange;
    } | {
        oneofKind: "actorSpawnFailedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.ActorSpawnFailedEvent actor_spawn_failed_event = 88
         */
        actorSpawnFailedEvent: ActorSpawnFailedEvent;
    } | {
        oneofKind: "sessionForkedEvent";
        /**
         * @generated from protobuf field: agency.events.v1.SessionForkedEvent session_forked_event = 89
         */
        sessionForkedEvent: SessionForkedEvent;
    } | {
        oneofKind: undefined;
    };
}
/**
 * EnvelopeValidationResult describes the validation outcome.
 *
 * @generated from protobuf message agency.envelope.v1.EnvelopeValidationResult
 */
export interface EnvelopeValidationResult {
    /**
     * valid indicates if the envelope passed validation.
     *
     * @generated from protobuf field: bool valid = 1
     */
    valid: boolean;
    /**
     * error_message describes validation failures.
     *
     * @generated from protobuf field: string error_message = 2
     */
    errorMessage: string;
    /**
     * validation_stage indicates where validation failed.
     *
     * @generated from protobuf field: agency.envelope.v1.ValidationStage validation_stage = 3
     */
    validationStage: ValidationStage;
    /**
     * claims are the validated claims (only if valid).
     *
     * @generated from protobuf field: agency.auth.v1.Claims claims = 4
     */
    claims?: Claims;
    /**
     * validated_at is when validation occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp validated_at = 5
     */
    validatedAt?: Timestamp;
}
/**
 * ValidationStage indicates where envelope validation occurred.
 *
 * @generated from protobuf enum agency.envelope.v1.ValidationStage
 */
export enum ValidationStage {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: VALIDATION_STAGE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * CLAIMS_VALIDATION validates the claims signature and expiry.
     *
     * @generated from protobuf enum value: VALIDATION_STAGE_CLAIMS_VALIDATION = 1;
     */
    CLAIMS_VALIDATION = 1,
    /**
     * TENANT_AUTHORIZATION validates tenant access.
     *
     * @generated from protobuf enum value: VALIDATION_STAGE_TENANT_AUTHORIZATION = 2;
     */
    TENANT_AUTHORIZATION = 2,
    /**
     * WORKSPACE_AUTHORIZATION validates workspace access.
     *
     * @generated from protobuf enum value: VALIDATION_STAGE_WORKSPACE_AUTHORIZATION = 3;
     */
    WORKSPACE_AUTHORIZATION = 3,
    /**
     * PAYLOAD_VALIDATION validates the payload structure.
     *
     * @generated from protobuf enum value: VALIDATION_STAGE_PAYLOAD_VALIDATION = 4;
     */
    PAYLOAD_VALIDATION = 4,
    /**
     * VERSION_COMPATIBILITY validates harness version compatibility.
     *
     * @generated from protobuf enum value: VALIDATION_STAGE_VERSION_COMPATIBILITY = 5;
     */
    VERSION_COMPATIBILITY = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class TraceContext$Type extends MessageType<TraceContext> {
    constructor() {
        super("agency.envelope.v1.TraceContext", [
            { no: 1, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "32", pattern: "^[0-9a-f]{32}$" } } } },
            { no: 2, name: "span_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "16", pattern: "^[0-9a-f]{16}$" } } } },
            { no: 3, name: "trace_flags", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 255 } } } },
            { no: 4, name: "parent_span_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { pattern: "^([0-9a-f]{16})?$" } } } },
            { no: 5, name: "baggage", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "32", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "512" } } } } } }
        ]);
    }
    create(value?: PartialMessage<TraceContext>): TraceContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.traceId = "";
        message.spanId = "";
        message.traceFlags = 0;
        message.parentSpanId = "";
        message.baggage = {};
        if (value !== undefined)
            reflectionMergePartial<TraceContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TraceContext): TraceContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string trace_id */ 1:
                    message.traceId = reader.string();
                    break;
                case /* string span_id */ 2:
                    message.spanId = reader.string();
                    break;
                case /* uint32 trace_flags */ 3:
                    message.traceFlags = reader.uint32();
                    break;
                case /* string parent_span_id */ 4:
                    message.parentSpanId = reader.string();
                    break;
                case /* map<string, string> baggage */ 5:
                    this.binaryReadMap5(message.baggage, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: TraceContext["baggage"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof TraceContext["baggage"] | undefined, val: TraceContext["baggage"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.envelope.v1.TraceContext.baggage");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: TraceContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string trace_id = 1; */
        if (message.traceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.traceId);
        /* string span_id = 2; */
        if (message.spanId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.spanId);
        /* uint32 trace_flags = 3; */
        if (message.traceFlags !== 0)
            writer.tag(3, WireType.Varint).uint32(message.traceFlags);
        /* string parent_span_id = 4; */
        if (message.parentSpanId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.parentSpanId);
        /* map<string, string> baggage = 5; */
        for (let k of globalThis.Object.keys(message.baggage))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.baggage[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.envelope.v1.TraceContext
 */
export const TraceContext = new TraceContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Envelope$Type extends MessageType<Envelope> {
    constructor() {
        super("agency.envelope.v1.Envelope", [
            { no: 1, name: "claims", kind: "message", T: () => Claims, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "trace_context", kind: "message", T: () => TraceContext },
            { no: 3, name: "harness_version", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 65535, gte: 1 } } } },
            { no: 10, name: "plan_event", kind: "message", oneof: "payload", T: () => PlanEvent },
            { no: 11, name: "step_event", kind: "message", oneof: "payload", T: () => StepEvent },
            { no: 12, name: "agent_done_event", kind: "message", oneof: "payload", T: () => AgentDoneEvent },
            { no: 13, name: "session_failed_event", kind: "message", oneof: "payload", T: () => SessionFailedEvent },
            { no: 14, name: "session_start_failed_event", kind: "message", oneof: "payload", T: () => SessionStartFailedEvent },
            { no: 15, name: "cancelled_event", kind: "message", oneof: "payload", T: () => CancelledEvent },
            { no: 16, name: "interrupt_event", kind: "message", oneof: "payload", T: () => InterruptEvent },
            { no: 20, name: "turn_start", kind: "message", oneof: "payload", T: () => TurnStart },
            { no: 21, name: "turn_end", kind: "message", oneof: "payload", T: () => TurnEnd },
            { no: 22, name: "message_start", kind: "message", oneof: "payload", T: () => MessageStart },
            { no: 23, name: "message_update", kind: "message", oneof: "payload", T: () => MessageUpdate },
            { no: 24, name: "assistant_message_delta", kind: "message", oneof: "payload", T: () => AssistantMessageDelta },
            { no: 25, name: "message_end", kind: "message", oneof: "payload", T: () => MessageEnd },
            { no: 30, name: "tool_execution_start", kind: "message", oneof: "payload", T: () => ToolExecutionStart },
            { no: 31, name: "tool_execution_update", kind: "message", oneof: "payload", T: () => ToolExecutionUpdate },
            { no: 32, name: "tool_execution_end", kind: "message", oneof: "payload", T: () => ToolExecutionEnd },
            { no: 33, name: "tool_call", kind: "message", oneof: "payload", T: () => ToolCall },
            { no: 34, name: "tool_result", kind: "message", oneof: "payload", T: () => ToolResult },
            { no: 40, name: "context_updated", kind: "message", oneof: "payload", T: () => ContextUpdated },
            { no: 41, name: "context_ready", kind: "message", oneof: "payload", T: () => ContextReady },
            { no: 42, name: "artifact_updated", kind: "message", oneof: "payload", T: () => ArtifactUpdated },
            { no: 43, name: "artifact_invalidation_event", kind: "message", oneof: "payload", T: () => ArtifactInvalidationEvent },
            { no: 50, name: "tool_call_frequency_exceeded_event", kind: "message", oneof: "payload", T: () => ToolCallFrequencyExceededEvent },
            { no: 51, name: "rate_limited_event", kind: "message", oneof: "payload", T: () => RateLimitedEvent },
            { no: 52, name: "quota_exhausted_event", kind: "message", oneof: "payload", T: () => QuotaExhaustedEvent },
            { no: 60, name: "harness_ready_event", kind: "message", oneof: "payload", T: () => HarnessReadyEvent },
            { no: 61, name: "harness_shutdown_event", kind: "message", oneof: "payload", T: () => HarnessShutdownEvent },
            { no: 70, name: "tool_rejection_event", kind: "message", oneof: "payload", T: () => ToolRejectionEvent },
            { no: 71, name: "request_failed_event", kind: "message", oneof: "payload", T: () => RequestFailedEvent },
            { no: 72, name: "model_fallback_event", kind: "message", oneof: "payload", T: () => ModelFallbackEvent },
            { no: 73, name: "dlq_alert_event", kind: "message", oneof: "payload", T: () => DLQAlertEvent },
            { no: 80, name: "skill_execution_event", kind: "message", oneof: "payload", T: () => SkillExecutionEvent },
            { no: 81, name: "snapshot_event", kind: "message", oneof: "payload", T: () => SnapshotEvent },
            { no: 82, name: "tenant_context_event", kind: "message", oneof: "payload", T: () => TenantContextEvent },
            { no: 83, name: "llm_call_start", kind: "message", oneof: "payload", T: () => LLMCallStart },
            { no: 84, name: "llm_call_end", kind: "message", oneof: "payload", T: () => LLMCallEnd },
            { no: 85, name: "session_started_event", kind: "message", oneof: "payload", T: () => SessionStartedEvent },
            { no: 86, name: "session_ended_event", kind: "message", oneof: "payload", T: () => SessionEndedEvent },
            { no: 87, name: "model_circuit_breaker_state_change", kind: "message", oneof: "payload", T: () => ModelCircuitBreakerStateChange },
            { no: 88, name: "actor_spawn_failed_event", kind: "message", oneof: "payload", T: () => ActorSpawnFailedEvent },
            { no: 89, name: "session_forked_event", kind: "message", oneof: "payload", T: () => SessionForkedEvent },
            { no: 5, name: "nats_msg_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256", pattern: "^[a-z0-9][a-z0-9._-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<Envelope>): Envelope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.harnessVersion = 0;
        message.payload = { oneofKind: undefined };
        message.natsMsgId = "";
        if (value !== undefined)
            reflectionMergePartial<Envelope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Envelope): Envelope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.auth.v1.Claims claims */ 1:
                    message.claims = Claims.internalBinaryRead(reader, reader.uint32(), options, message.claims);
                    break;
                case /* agency.envelope.v1.TraceContext trace_context */ 2:
                    message.traceContext = TraceContext.internalBinaryRead(reader, reader.uint32(), options, message.traceContext);
                    break;
                case /* uint32 harness_version */ 3:
                    message.harnessVersion = reader.uint32();
                    break;
                case /* agency.events.v1.PlanEvent plan_event */ 10:
                    message.payload = {
                        oneofKind: "planEvent",
                        planEvent: PlanEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).planEvent)
                    };
                    break;
                case /* agency.events.v1.StepEvent step_event */ 11:
                    message.payload = {
                        oneofKind: "stepEvent",
                        stepEvent: StepEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).stepEvent)
                    };
                    break;
                case /* agency.events.v1.AgentDoneEvent agent_done_event */ 12:
                    message.payload = {
                        oneofKind: "agentDoneEvent",
                        agentDoneEvent: AgentDoneEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).agentDoneEvent)
                    };
                    break;
                case /* agency.events.v1.SessionFailedEvent session_failed_event */ 13:
                    message.payload = {
                        oneofKind: "sessionFailedEvent",
                        sessionFailedEvent: SessionFailedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sessionFailedEvent)
                    };
                    break;
                case /* agency.events.v1.SessionStartFailedEvent session_start_failed_event */ 14:
                    message.payload = {
                        oneofKind: "sessionStartFailedEvent",
                        sessionStartFailedEvent: SessionStartFailedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sessionStartFailedEvent)
                    };
                    break;
                case /* agency.events.v1.CancelledEvent cancelled_event */ 15:
                    message.payload = {
                        oneofKind: "cancelledEvent",
                        cancelledEvent: CancelledEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).cancelledEvent)
                    };
                    break;
                case /* agency.events.v1.InterruptEvent interrupt_event */ 16:
                    message.payload = {
                        oneofKind: "interruptEvent",
                        interruptEvent: InterruptEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).interruptEvent)
                    };
                    break;
                case /* agency.events.v1.TurnStart turn_start */ 20:
                    message.payload = {
                        oneofKind: "turnStart",
                        turnStart: TurnStart.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).turnStart)
                    };
                    break;
                case /* agency.events.v1.TurnEnd turn_end */ 21:
                    message.payload = {
                        oneofKind: "turnEnd",
                        turnEnd: TurnEnd.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).turnEnd)
                    };
                    break;
                case /* agency.events.v1.MessageStart message_start */ 22:
                    message.payload = {
                        oneofKind: "messageStart",
                        messageStart: MessageStart.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).messageStart)
                    };
                    break;
                case /* agency.events.v1.MessageUpdate message_update */ 23:
                    message.payload = {
                        oneofKind: "messageUpdate",
                        messageUpdate: MessageUpdate.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).messageUpdate)
                    };
                    break;
                case /* agency.events.v1.AssistantMessageDelta assistant_message_delta */ 24:
                    message.payload = {
                        oneofKind: "assistantMessageDelta",
                        assistantMessageDelta: AssistantMessageDelta.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).assistantMessageDelta)
                    };
                    break;
                case /* agency.events.v1.MessageEnd message_end */ 25:
                    message.payload = {
                        oneofKind: "messageEnd",
                        messageEnd: MessageEnd.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).messageEnd)
                    };
                    break;
                case /* agency.events.v1.ToolExecutionStart tool_execution_start */ 30:
                    message.payload = {
                        oneofKind: "toolExecutionStart",
                        toolExecutionStart: ToolExecutionStart.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolExecutionStart)
                    };
                    break;
                case /* agency.events.v1.ToolExecutionUpdate tool_execution_update */ 31:
                    message.payload = {
                        oneofKind: "toolExecutionUpdate",
                        toolExecutionUpdate: ToolExecutionUpdate.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolExecutionUpdate)
                    };
                    break;
                case /* agency.events.v1.ToolExecutionEnd tool_execution_end */ 32:
                    message.payload = {
                        oneofKind: "toolExecutionEnd",
                        toolExecutionEnd: ToolExecutionEnd.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolExecutionEnd)
                    };
                    break;
                case /* agency.tool.v1.ToolCall tool_call */ 33:
                    message.payload = {
                        oneofKind: "toolCall",
                        toolCall: ToolCall.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolCall)
                    };
                    break;
                case /* agency.tool.v1.ToolResult tool_result */ 34:
                    message.payload = {
                        oneofKind: "toolResult",
                        toolResult: ToolResult.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolResult)
                    };
                    break;
                case /* agency.events.v1.ContextUpdated context_updated */ 40:
                    message.payload = {
                        oneofKind: "contextUpdated",
                        contextUpdated: ContextUpdated.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).contextUpdated)
                    };
                    break;
                case /* agency.events.v1.ContextReady context_ready */ 41:
                    message.payload = {
                        oneofKind: "contextReady",
                        contextReady: ContextReady.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).contextReady)
                    };
                    break;
                case /* agency.events.v1.ArtifactUpdated artifact_updated */ 42:
                    message.payload = {
                        oneofKind: "artifactUpdated",
                        artifactUpdated: ArtifactUpdated.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).artifactUpdated)
                    };
                    break;
                case /* agency.events.v1.ArtifactInvalidationEvent artifact_invalidation_event */ 43:
                    message.payload = {
                        oneofKind: "artifactInvalidationEvent",
                        artifactInvalidationEvent: ArtifactInvalidationEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).artifactInvalidationEvent)
                    };
                    break;
                case /* agency.events.v1.ToolCallFrequencyExceededEvent tool_call_frequency_exceeded_event */ 50:
                    message.payload = {
                        oneofKind: "toolCallFrequencyExceededEvent",
                        toolCallFrequencyExceededEvent: ToolCallFrequencyExceededEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolCallFrequencyExceededEvent)
                    };
                    break;
                case /* agency.events.v1.RateLimitedEvent rate_limited_event */ 51:
                    message.payload = {
                        oneofKind: "rateLimitedEvent",
                        rateLimitedEvent: RateLimitedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).rateLimitedEvent)
                    };
                    break;
                case /* agency.quota.v1.QuotaExhaustedEvent quota_exhausted_event */ 52:
                    message.payload = {
                        oneofKind: "quotaExhaustedEvent",
                        quotaExhaustedEvent: QuotaExhaustedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).quotaExhaustedEvent)
                    };
                    break;
                case /* agency.events.v1.HarnessReadyEvent harness_ready_event */ 60:
                    message.payload = {
                        oneofKind: "harnessReadyEvent",
                        harnessReadyEvent: HarnessReadyEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).harnessReadyEvent)
                    };
                    break;
                case /* agency.events.v1.HarnessShutdownEvent harness_shutdown_event */ 61:
                    message.payload = {
                        oneofKind: "harnessShutdownEvent",
                        harnessShutdownEvent: HarnessShutdownEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).harnessShutdownEvent)
                    };
                    break;
                case /* agency.events.v1.ToolRejectionEvent tool_rejection_event */ 70:
                    message.payload = {
                        oneofKind: "toolRejectionEvent",
                        toolRejectionEvent: ToolRejectionEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolRejectionEvent)
                    };
                    break;
                case /* agency.events.v1.RequestFailedEvent request_failed_event */ 71:
                    message.payload = {
                        oneofKind: "requestFailedEvent",
                        requestFailedEvent: RequestFailedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).requestFailedEvent)
                    };
                    break;
                case /* agency.events.v1.ModelFallbackEvent model_fallback_event */ 72:
                    message.payload = {
                        oneofKind: "modelFallbackEvent",
                        modelFallbackEvent: ModelFallbackEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).modelFallbackEvent)
                    };
                    break;
                case /* agency.events.v1.DLQAlertEvent dlq_alert_event */ 73:
                    message.payload = {
                        oneofKind: "dlqAlertEvent",
                        dlqAlertEvent: DLQAlertEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).dlqAlertEvent)
                    };
                    break;
                case /* agency.events.v1.SkillExecutionEvent skill_execution_event */ 80:
                    message.payload = {
                        oneofKind: "skillExecutionEvent",
                        skillExecutionEvent: SkillExecutionEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).skillExecutionEvent)
                    };
                    break;
                case /* agency.events.v1.SnapshotEvent snapshot_event */ 81:
                    message.payload = {
                        oneofKind: "snapshotEvent",
                        snapshotEvent: SnapshotEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).snapshotEvent)
                    };
                    break;
                case /* agency.events.v1.TenantContextEvent tenant_context_event */ 82:
                    message.payload = {
                        oneofKind: "tenantContextEvent",
                        tenantContextEvent: TenantContextEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).tenantContextEvent)
                    };
                    break;
                case /* agency.events.v1.LLMCallStart llm_call_start */ 83:
                    message.payload = {
                        oneofKind: "llmCallStart",
                        llmCallStart: LLMCallStart.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).llmCallStart)
                    };
                    break;
                case /* agency.events.v1.LLMCallEnd llm_call_end */ 84:
                    message.payload = {
                        oneofKind: "llmCallEnd",
                        llmCallEnd: LLMCallEnd.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).llmCallEnd)
                    };
                    break;
                case /* agency.events.v1.SessionStartedEvent session_started_event */ 85:
                    message.payload = {
                        oneofKind: "sessionStartedEvent",
                        sessionStartedEvent: SessionStartedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sessionStartedEvent)
                    };
                    break;
                case /* agency.events.v1.SessionEndedEvent session_ended_event */ 86:
                    message.payload = {
                        oneofKind: "sessionEndedEvent",
                        sessionEndedEvent: SessionEndedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sessionEndedEvent)
                    };
                    break;
                case /* agency.events.v1.ModelCircuitBreakerStateChange model_circuit_breaker_state_change */ 87:
                    message.payload = {
                        oneofKind: "modelCircuitBreakerStateChange",
                        modelCircuitBreakerStateChange: ModelCircuitBreakerStateChange.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).modelCircuitBreakerStateChange)
                    };
                    break;
                case /* agency.events.v1.ActorSpawnFailedEvent actor_spawn_failed_event */ 88:
                    message.payload = {
                        oneofKind: "actorSpawnFailedEvent",
                        actorSpawnFailedEvent: ActorSpawnFailedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).actorSpawnFailedEvent)
                    };
                    break;
                case /* agency.events.v1.SessionForkedEvent session_forked_event */ 89:
                    message.payload = {
                        oneofKind: "sessionForkedEvent",
                        sessionForkedEvent: SessionForkedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sessionForkedEvent)
                    };
                    break;
                case /* string nats_msg_id */ 5:
                    message.natsMsgId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Envelope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.auth.v1.Claims claims = 1; */
        if (message.claims)
            Claims.internalBinaryWrite(message.claims, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.envelope.v1.TraceContext trace_context = 2; */
        if (message.traceContext)
            TraceContext.internalBinaryWrite(message.traceContext, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* uint32 harness_version = 3; */
        if (message.harnessVersion !== 0)
            writer.tag(3, WireType.Varint).uint32(message.harnessVersion);
        /* string nats_msg_id = 5; */
        if (message.natsMsgId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.natsMsgId);
        /* agency.events.v1.PlanEvent plan_event = 10; */
        if (message.payload.oneofKind === "planEvent")
            PlanEvent.internalBinaryWrite(message.payload.planEvent, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.StepEvent step_event = 11; */
        if (message.payload.oneofKind === "stepEvent")
            StepEvent.internalBinaryWrite(message.payload.stepEvent, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.AgentDoneEvent agent_done_event = 12; */
        if (message.payload.oneofKind === "agentDoneEvent")
            AgentDoneEvent.internalBinaryWrite(message.payload.agentDoneEvent, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SessionFailedEvent session_failed_event = 13; */
        if (message.payload.oneofKind === "sessionFailedEvent")
            SessionFailedEvent.internalBinaryWrite(message.payload.sessionFailedEvent, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SessionStartFailedEvent session_start_failed_event = 14; */
        if (message.payload.oneofKind === "sessionStartFailedEvent")
            SessionStartFailedEvent.internalBinaryWrite(message.payload.sessionStartFailedEvent, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.CancelledEvent cancelled_event = 15; */
        if (message.payload.oneofKind === "cancelledEvent")
            CancelledEvent.internalBinaryWrite(message.payload.cancelledEvent, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.InterruptEvent interrupt_event = 16; */
        if (message.payload.oneofKind === "interruptEvent")
            InterruptEvent.internalBinaryWrite(message.payload.interruptEvent, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.TurnStart turn_start = 20; */
        if (message.payload.oneofKind === "turnStart")
            TurnStart.internalBinaryWrite(message.payload.turnStart, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.TurnEnd turn_end = 21; */
        if (message.payload.oneofKind === "turnEnd")
            TurnEnd.internalBinaryWrite(message.payload.turnEnd, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.MessageStart message_start = 22; */
        if (message.payload.oneofKind === "messageStart")
            MessageStart.internalBinaryWrite(message.payload.messageStart, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.MessageUpdate message_update = 23; */
        if (message.payload.oneofKind === "messageUpdate")
            MessageUpdate.internalBinaryWrite(message.payload.messageUpdate, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.AssistantMessageDelta assistant_message_delta = 24; */
        if (message.payload.oneofKind === "assistantMessageDelta")
            AssistantMessageDelta.internalBinaryWrite(message.payload.assistantMessageDelta, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.MessageEnd message_end = 25; */
        if (message.payload.oneofKind === "messageEnd")
            MessageEnd.internalBinaryWrite(message.payload.messageEnd, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ToolExecutionStart tool_execution_start = 30; */
        if (message.payload.oneofKind === "toolExecutionStart")
            ToolExecutionStart.internalBinaryWrite(message.payload.toolExecutionStart, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ToolExecutionUpdate tool_execution_update = 31; */
        if (message.payload.oneofKind === "toolExecutionUpdate")
            ToolExecutionUpdate.internalBinaryWrite(message.payload.toolExecutionUpdate, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ToolExecutionEnd tool_execution_end = 32; */
        if (message.payload.oneofKind === "toolExecutionEnd")
            ToolExecutionEnd.internalBinaryWrite(message.payload.toolExecutionEnd, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* agency.tool.v1.ToolCall tool_call = 33; */
        if (message.payload.oneofKind === "toolCall")
            ToolCall.internalBinaryWrite(message.payload.toolCall, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* agency.tool.v1.ToolResult tool_result = 34; */
        if (message.payload.oneofKind === "toolResult")
            ToolResult.internalBinaryWrite(message.payload.toolResult, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ContextUpdated context_updated = 40; */
        if (message.payload.oneofKind === "contextUpdated")
            ContextUpdated.internalBinaryWrite(message.payload.contextUpdated, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ContextReady context_ready = 41; */
        if (message.payload.oneofKind === "contextReady")
            ContextReady.internalBinaryWrite(message.payload.contextReady, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ArtifactUpdated artifact_updated = 42; */
        if (message.payload.oneofKind === "artifactUpdated")
            ArtifactUpdated.internalBinaryWrite(message.payload.artifactUpdated, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ArtifactInvalidationEvent artifact_invalidation_event = 43; */
        if (message.payload.oneofKind === "artifactInvalidationEvent")
            ArtifactInvalidationEvent.internalBinaryWrite(message.payload.artifactInvalidationEvent, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ToolCallFrequencyExceededEvent tool_call_frequency_exceeded_event = 50; */
        if (message.payload.oneofKind === "toolCallFrequencyExceededEvent")
            ToolCallFrequencyExceededEvent.internalBinaryWrite(message.payload.toolCallFrequencyExceededEvent, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.RateLimitedEvent rate_limited_event = 51; */
        if (message.payload.oneofKind === "rateLimitedEvent")
            RateLimitedEvent.internalBinaryWrite(message.payload.rateLimitedEvent, writer.tag(51, WireType.LengthDelimited).fork(), options).join();
        /* agency.quota.v1.QuotaExhaustedEvent quota_exhausted_event = 52; */
        if (message.payload.oneofKind === "quotaExhaustedEvent")
            QuotaExhaustedEvent.internalBinaryWrite(message.payload.quotaExhaustedEvent, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.HarnessReadyEvent harness_ready_event = 60; */
        if (message.payload.oneofKind === "harnessReadyEvent")
            HarnessReadyEvent.internalBinaryWrite(message.payload.harnessReadyEvent, writer.tag(60, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.HarnessShutdownEvent harness_shutdown_event = 61; */
        if (message.payload.oneofKind === "harnessShutdownEvent")
            HarnessShutdownEvent.internalBinaryWrite(message.payload.harnessShutdownEvent, writer.tag(61, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ToolRejectionEvent tool_rejection_event = 70; */
        if (message.payload.oneofKind === "toolRejectionEvent")
            ToolRejectionEvent.internalBinaryWrite(message.payload.toolRejectionEvent, writer.tag(70, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.RequestFailedEvent request_failed_event = 71; */
        if (message.payload.oneofKind === "requestFailedEvent")
            RequestFailedEvent.internalBinaryWrite(message.payload.requestFailedEvent, writer.tag(71, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ModelFallbackEvent model_fallback_event = 72; */
        if (message.payload.oneofKind === "modelFallbackEvent")
            ModelFallbackEvent.internalBinaryWrite(message.payload.modelFallbackEvent, writer.tag(72, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.DLQAlertEvent dlq_alert_event = 73; */
        if (message.payload.oneofKind === "dlqAlertEvent")
            DLQAlertEvent.internalBinaryWrite(message.payload.dlqAlertEvent, writer.tag(73, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SkillExecutionEvent skill_execution_event = 80; */
        if (message.payload.oneofKind === "skillExecutionEvent")
            SkillExecutionEvent.internalBinaryWrite(message.payload.skillExecutionEvent, writer.tag(80, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SnapshotEvent snapshot_event = 81; */
        if (message.payload.oneofKind === "snapshotEvent")
            SnapshotEvent.internalBinaryWrite(message.payload.snapshotEvent, writer.tag(81, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.TenantContextEvent tenant_context_event = 82; */
        if (message.payload.oneofKind === "tenantContextEvent")
            TenantContextEvent.internalBinaryWrite(message.payload.tenantContextEvent, writer.tag(82, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.LLMCallStart llm_call_start = 83; */
        if (message.payload.oneofKind === "llmCallStart")
            LLMCallStart.internalBinaryWrite(message.payload.llmCallStart, writer.tag(83, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.LLMCallEnd llm_call_end = 84; */
        if (message.payload.oneofKind === "llmCallEnd")
            LLMCallEnd.internalBinaryWrite(message.payload.llmCallEnd, writer.tag(84, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SessionStartedEvent session_started_event = 85; */
        if (message.payload.oneofKind === "sessionStartedEvent")
            SessionStartedEvent.internalBinaryWrite(message.payload.sessionStartedEvent, writer.tag(85, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SessionEndedEvent session_ended_event = 86; */
        if (message.payload.oneofKind === "sessionEndedEvent")
            SessionEndedEvent.internalBinaryWrite(message.payload.sessionEndedEvent, writer.tag(86, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ModelCircuitBreakerStateChange model_circuit_breaker_state_change = 87; */
        if (message.payload.oneofKind === "modelCircuitBreakerStateChange")
            ModelCircuitBreakerStateChange.internalBinaryWrite(message.payload.modelCircuitBreakerStateChange, writer.tag(87, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ActorSpawnFailedEvent actor_spawn_failed_event = 88; */
        if (message.payload.oneofKind === "actorSpawnFailedEvent")
            ActorSpawnFailedEvent.internalBinaryWrite(message.payload.actorSpawnFailedEvent, writer.tag(88, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SessionForkedEvent session_forked_event = 89; */
        if (message.payload.oneofKind === "sessionForkedEvent")
            SessionForkedEvent.internalBinaryWrite(message.payload.sessionForkedEvent, writer.tag(89, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.envelope.v1.Envelope
 */
export const Envelope = new Envelope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IngressEnvelope$Type extends MessageType<IngressEnvelope> {
    constructor() {
        super("agency.envelope.v1.IngressEnvelope", [
            { no: 1, name: "claims", kind: "message", T: () => Claims, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "trace_context", kind: "message", T: () => TraceContext },
            { no: 3, name: "harness_version", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 65535, gte: 1 } } } },
            { no: 4, name: "payload", kind: "message", T: () => Message, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "nats_msg_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256", pattern: "^[a-z0-9][a-z0-9._-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<IngressEnvelope>): IngressEnvelope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.harnessVersion = 0;
        message.natsMsgId = "";
        if (value !== undefined)
            reflectionMergePartial<IngressEnvelope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IngressEnvelope): IngressEnvelope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.auth.v1.Claims claims */ 1:
                    message.claims = Claims.internalBinaryRead(reader, reader.uint32(), options, message.claims);
                    break;
                case /* agency.envelope.v1.TraceContext trace_context */ 2:
                    message.traceContext = TraceContext.internalBinaryRead(reader, reader.uint32(), options, message.traceContext);
                    break;
                case /* uint32 harness_version */ 3:
                    message.harnessVersion = reader.uint32();
                    break;
                case /* agency.session.v1.Message payload */ 4:
                    message.payload = Message.internalBinaryRead(reader, reader.uint32(), options, message.payload);
                    break;
                case /* string nats_msg_id */ 5:
                    message.natsMsgId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IngressEnvelope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.auth.v1.Claims claims = 1; */
        if (message.claims)
            Claims.internalBinaryWrite(message.claims, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.envelope.v1.TraceContext trace_context = 2; */
        if (message.traceContext)
            TraceContext.internalBinaryWrite(message.traceContext, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* uint32 harness_version = 3; */
        if (message.harnessVersion !== 0)
            writer.tag(3, WireType.Varint).uint32(message.harnessVersion);
        /* agency.session.v1.Message payload = 4; */
        if (message.payload)
            Message.internalBinaryWrite(message.payload, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string nats_msg_id = 5; */
        if (message.natsMsgId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.natsMsgId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.envelope.v1.IngressEnvelope
 */
export const IngressEnvelope = new IngressEnvelope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnvelopeUnwrapRequest$Type extends MessageType<EnvelopeUnwrapRequest> {
    constructor() {
        super("agency.envelope.v1.EnvelopeUnwrapRequest", [
            { no: 1, name: "envelope", kind: "message", T: () => Envelope, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "require_tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "require_workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<EnvelopeUnwrapRequest>): EnvelopeUnwrapRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requireTenant = "";
        message.requireWorkspace = "";
        if (value !== undefined)
            reflectionMergePartial<EnvelopeUnwrapRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnvelopeUnwrapRequest): EnvelopeUnwrapRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.envelope.v1.Envelope envelope */ 1:
                    message.envelope = Envelope.internalBinaryRead(reader, reader.uint32(), options, message.envelope);
                    break;
                case /* string require_tenant */ 2:
                    message.requireTenant = reader.string();
                    break;
                case /* string require_workspace */ 3:
                    message.requireWorkspace = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnvelopeUnwrapRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.envelope.v1.Envelope envelope = 1; */
        if (message.envelope)
            Envelope.internalBinaryWrite(message.envelope, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string require_tenant = 2; */
        if (message.requireTenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requireTenant);
        /* string require_workspace = 3; */
        if (message.requireWorkspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requireWorkspace);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.envelope.v1.EnvelopeUnwrapRequest
 */
export const EnvelopeUnwrapRequest = new EnvelopeUnwrapRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnvelopeUnwrapResponse$Type extends MessageType<EnvelopeUnwrapResponse> {
    constructor() {
        super("agency.envelope.v1.EnvelopeUnwrapResponse", [
            { no: 1, name: "validation_result", kind: "message", T: () => EnvelopeValidationResult, options: { "buf.validate.field": { required: true } } },
            { no: 10, name: "plan_event", kind: "message", oneof: "payload", T: () => PlanEvent },
            { no: 11, name: "step_event", kind: "message", oneof: "payload", T: () => StepEvent },
            { no: 12, name: "agent_done_event", kind: "message", oneof: "payload", T: () => AgentDoneEvent },
            { no: 13, name: "session_failed_event", kind: "message", oneof: "payload", T: () => SessionFailedEvent },
            { no: 14, name: "session_start_failed_event", kind: "message", oneof: "payload", T: () => SessionStartFailedEvent },
            { no: 15, name: "cancelled_event", kind: "message", oneof: "payload", T: () => CancelledEvent },
            { no: 16, name: "interrupt_event", kind: "message", oneof: "payload", T: () => InterruptEvent },
            { no: 20, name: "turn_start", kind: "message", oneof: "payload", T: () => TurnStart },
            { no: 21, name: "turn_end", kind: "message", oneof: "payload", T: () => TurnEnd },
            { no: 22, name: "message_start", kind: "message", oneof: "payload", T: () => MessageStart },
            { no: 23, name: "message_update", kind: "message", oneof: "payload", T: () => MessageUpdate },
            { no: 24, name: "assistant_message_delta", kind: "message", oneof: "payload", T: () => AssistantMessageDelta },
            { no: 25, name: "message_end", kind: "message", oneof: "payload", T: () => MessageEnd },
            { no: 30, name: "tool_execution_start", kind: "message", oneof: "payload", T: () => ToolExecutionStart },
            { no: 31, name: "tool_execution_update", kind: "message", oneof: "payload", T: () => ToolExecutionUpdate },
            { no: 32, name: "tool_execution_end", kind: "message", oneof: "payload", T: () => ToolExecutionEnd },
            { no: 33, name: "tool_call", kind: "message", oneof: "payload", T: () => ToolCall },
            { no: 34, name: "tool_result", kind: "message", oneof: "payload", T: () => ToolResult },
            { no: 40, name: "context_updated", kind: "message", oneof: "payload", T: () => ContextUpdated },
            { no: 41, name: "context_ready", kind: "message", oneof: "payload", T: () => ContextReady },
            { no: 42, name: "artifact_updated", kind: "message", oneof: "payload", T: () => ArtifactUpdated },
            { no: 43, name: "artifact_invalidation_event", kind: "message", oneof: "payload", T: () => ArtifactInvalidationEvent },
            { no: 50, name: "tool_call_frequency_exceeded_event", kind: "message", oneof: "payload", T: () => ToolCallFrequencyExceededEvent },
            { no: 51, name: "rate_limited_event", kind: "message", oneof: "payload", T: () => RateLimitedEvent },
            { no: 52, name: "quota_exhausted_event", kind: "message", oneof: "payload", T: () => QuotaExhaustedEvent },
            { no: 60, name: "harness_ready_event", kind: "message", oneof: "payload", T: () => HarnessReadyEvent },
            { no: 61, name: "harness_shutdown_event", kind: "message", oneof: "payload", T: () => HarnessShutdownEvent },
            { no: 70, name: "tool_rejection_event", kind: "message", oneof: "payload", T: () => ToolRejectionEvent },
            { no: 71, name: "request_failed_event", kind: "message", oneof: "payload", T: () => RequestFailedEvent },
            { no: 72, name: "model_fallback_event", kind: "message", oneof: "payload", T: () => ModelFallbackEvent },
            { no: 73, name: "dlq_alert_event", kind: "message", oneof: "payload", T: () => DLQAlertEvent },
            { no: 80, name: "skill_execution_event", kind: "message", oneof: "payload", T: () => SkillExecutionEvent },
            { no: 81, name: "snapshot_event", kind: "message", oneof: "payload", T: () => SnapshotEvent },
            { no: 82, name: "tenant_context_event", kind: "message", oneof: "payload", T: () => TenantContextEvent },
            { no: 83, name: "llm_call_start", kind: "message", oneof: "payload", T: () => LLMCallStart },
            { no: 84, name: "llm_call_end", kind: "message", oneof: "payload", T: () => LLMCallEnd },
            { no: 85, name: "session_started_event", kind: "message", oneof: "payload", T: () => SessionStartedEvent },
            { no: 86, name: "session_ended_event", kind: "message", oneof: "payload", T: () => SessionEndedEvent },
            { no: 87, name: "model_circuit_breaker_state_change", kind: "message", oneof: "payload", T: () => ModelCircuitBreakerStateChange },
            { no: 88, name: "actor_spawn_failed_event", kind: "message", oneof: "payload", T: () => ActorSpawnFailedEvent },
            { no: 89, name: "session_forked_event", kind: "message", oneof: "payload", T: () => SessionForkedEvent }
        ]);
    }
    create(value?: PartialMessage<EnvelopeUnwrapResponse>): EnvelopeUnwrapResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.payload = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<EnvelopeUnwrapResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnvelopeUnwrapResponse): EnvelopeUnwrapResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.envelope.v1.EnvelopeValidationResult validation_result */ 1:
                    message.validationResult = EnvelopeValidationResult.internalBinaryRead(reader, reader.uint32(), options, message.validationResult);
                    break;
                case /* agency.events.v1.PlanEvent plan_event */ 10:
                    message.payload = {
                        oneofKind: "planEvent",
                        planEvent: PlanEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).planEvent)
                    };
                    break;
                case /* agency.events.v1.StepEvent step_event */ 11:
                    message.payload = {
                        oneofKind: "stepEvent",
                        stepEvent: StepEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).stepEvent)
                    };
                    break;
                case /* agency.events.v1.AgentDoneEvent agent_done_event */ 12:
                    message.payload = {
                        oneofKind: "agentDoneEvent",
                        agentDoneEvent: AgentDoneEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).agentDoneEvent)
                    };
                    break;
                case /* agency.events.v1.SessionFailedEvent session_failed_event */ 13:
                    message.payload = {
                        oneofKind: "sessionFailedEvent",
                        sessionFailedEvent: SessionFailedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sessionFailedEvent)
                    };
                    break;
                case /* agency.events.v1.SessionStartFailedEvent session_start_failed_event */ 14:
                    message.payload = {
                        oneofKind: "sessionStartFailedEvent",
                        sessionStartFailedEvent: SessionStartFailedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sessionStartFailedEvent)
                    };
                    break;
                case /* agency.events.v1.CancelledEvent cancelled_event */ 15:
                    message.payload = {
                        oneofKind: "cancelledEvent",
                        cancelledEvent: CancelledEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).cancelledEvent)
                    };
                    break;
                case /* agency.events.v1.InterruptEvent interrupt_event */ 16:
                    message.payload = {
                        oneofKind: "interruptEvent",
                        interruptEvent: InterruptEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).interruptEvent)
                    };
                    break;
                case /* agency.events.v1.TurnStart turn_start */ 20:
                    message.payload = {
                        oneofKind: "turnStart",
                        turnStart: TurnStart.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).turnStart)
                    };
                    break;
                case /* agency.events.v1.TurnEnd turn_end */ 21:
                    message.payload = {
                        oneofKind: "turnEnd",
                        turnEnd: TurnEnd.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).turnEnd)
                    };
                    break;
                case /* agency.events.v1.MessageStart message_start */ 22:
                    message.payload = {
                        oneofKind: "messageStart",
                        messageStart: MessageStart.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).messageStart)
                    };
                    break;
                case /* agency.events.v1.MessageUpdate message_update */ 23:
                    message.payload = {
                        oneofKind: "messageUpdate",
                        messageUpdate: MessageUpdate.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).messageUpdate)
                    };
                    break;
                case /* agency.events.v1.AssistantMessageDelta assistant_message_delta */ 24:
                    message.payload = {
                        oneofKind: "assistantMessageDelta",
                        assistantMessageDelta: AssistantMessageDelta.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).assistantMessageDelta)
                    };
                    break;
                case /* agency.events.v1.MessageEnd message_end */ 25:
                    message.payload = {
                        oneofKind: "messageEnd",
                        messageEnd: MessageEnd.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).messageEnd)
                    };
                    break;
                case /* agency.events.v1.ToolExecutionStart tool_execution_start */ 30:
                    message.payload = {
                        oneofKind: "toolExecutionStart",
                        toolExecutionStart: ToolExecutionStart.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolExecutionStart)
                    };
                    break;
                case /* agency.events.v1.ToolExecutionUpdate tool_execution_update */ 31:
                    message.payload = {
                        oneofKind: "toolExecutionUpdate",
                        toolExecutionUpdate: ToolExecutionUpdate.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolExecutionUpdate)
                    };
                    break;
                case /* agency.events.v1.ToolExecutionEnd tool_execution_end */ 32:
                    message.payload = {
                        oneofKind: "toolExecutionEnd",
                        toolExecutionEnd: ToolExecutionEnd.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolExecutionEnd)
                    };
                    break;
                case /* agency.tool.v1.ToolCall tool_call */ 33:
                    message.payload = {
                        oneofKind: "toolCall",
                        toolCall: ToolCall.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolCall)
                    };
                    break;
                case /* agency.tool.v1.ToolResult tool_result */ 34:
                    message.payload = {
                        oneofKind: "toolResult",
                        toolResult: ToolResult.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolResult)
                    };
                    break;
                case /* agency.events.v1.ContextUpdated context_updated */ 40:
                    message.payload = {
                        oneofKind: "contextUpdated",
                        contextUpdated: ContextUpdated.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).contextUpdated)
                    };
                    break;
                case /* agency.events.v1.ContextReady context_ready */ 41:
                    message.payload = {
                        oneofKind: "contextReady",
                        contextReady: ContextReady.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).contextReady)
                    };
                    break;
                case /* agency.events.v1.ArtifactUpdated artifact_updated */ 42:
                    message.payload = {
                        oneofKind: "artifactUpdated",
                        artifactUpdated: ArtifactUpdated.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).artifactUpdated)
                    };
                    break;
                case /* agency.events.v1.ArtifactInvalidationEvent artifact_invalidation_event */ 43:
                    message.payload = {
                        oneofKind: "artifactInvalidationEvent",
                        artifactInvalidationEvent: ArtifactInvalidationEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).artifactInvalidationEvent)
                    };
                    break;
                case /* agency.events.v1.ToolCallFrequencyExceededEvent tool_call_frequency_exceeded_event */ 50:
                    message.payload = {
                        oneofKind: "toolCallFrequencyExceededEvent",
                        toolCallFrequencyExceededEvent: ToolCallFrequencyExceededEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolCallFrequencyExceededEvent)
                    };
                    break;
                case /* agency.events.v1.RateLimitedEvent rate_limited_event */ 51:
                    message.payload = {
                        oneofKind: "rateLimitedEvent",
                        rateLimitedEvent: RateLimitedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).rateLimitedEvent)
                    };
                    break;
                case /* agency.quota.v1.QuotaExhaustedEvent quota_exhausted_event */ 52:
                    message.payload = {
                        oneofKind: "quotaExhaustedEvent",
                        quotaExhaustedEvent: QuotaExhaustedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).quotaExhaustedEvent)
                    };
                    break;
                case /* agency.events.v1.HarnessReadyEvent harness_ready_event */ 60:
                    message.payload = {
                        oneofKind: "harnessReadyEvent",
                        harnessReadyEvent: HarnessReadyEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).harnessReadyEvent)
                    };
                    break;
                case /* agency.events.v1.HarnessShutdownEvent harness_shutdown_event */ 61:
                    message.payload = {
                        oneofKind: "harnessShutdownEvent",
                        harnessShutdownEvent: HarnessShutdownEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).harnessShutdownEvent)
                    };
                    break;
                case /* agency.events.v1.ToolRejectionEvent tool_rejection_event */ 70:
                    message.payload = {
                        oneofKind: "toolRejectionEvent",
                        toolRejectionEvent: ToolRejectionEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).toolRejectionEvent)
                    };
                    break;
                case /* agency.events.v1.RequestFailedEvent request_failed_event */ 71:
                    message.payload = {
                        oneofKind: "requestFailedEvent",
                        requestFailedEvent: RequestFailedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).requestFailedEvent)
                    };
                    break;
                case /* agency.events.v1.ModelFallbackEvent model_fallback_event */ 72:
                    message.payload = {
                        oneofKind: "modelFallbackEvent",
                        modelFallbackEvent: ModelFallbackEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).modelFallbackEvent)
                    };
                    break;
                case /* agency.events.v1.DLQAlertEvent dlq_alert_event */ 73:
                    message.payload = {
                        oneofKind: "dlqAlertEvent",
                        dlqAlertEvent: DLQAlertEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).dlqAlertEvent)
                    };
                    break;
                case /* agency.events.v1.SkillExecutionEvent skill_execution_event */ 80:
                    message.payload = {
                        oneofKind: "skillExecutionEvent",
                        skillExecutionEvent: SkillExecutionEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).skillExecutionEvent)
                    };
                    break;
                case /* agency.events.v1.SnapshotEvent snapshot_event */ 81:
                    message.payload = {
                        oneofKind: "snapshotEvent",
                        snapshotEvent: SnapshotEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).snapshotEvent)
                    };
                    break;
                case /* agency.events.v1.TenantContextEvent tenant_context_event */ 82:
                    message.payload = {
                        oneofKind: "tenantContextEvent",
                        tenantContextEvent: TenantContextEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).tenantContextEvent)
                    };
                    break;
                case /* agency.events.v1.LLMCallStart llm_call_start */ 83:
                    message.payload = {
                        oneofKind: "llmCallStart",
                        llmCallStart: LLMCallStart.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).llmCallStart)
                    };
                    break;
                case /* agency.events.v1.LLMCallEnd llm_call_end */ 84:
                    message.payload = {
                        oneofKind: "llmCallEnd",
                        llmCallEnd: LLMCallEnd.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).llmCallEnd)
                    };
                    break;
                case /* agency.events.v1.SessionStartedEvent session_started_event */ 85:
                    message.payload = {
                        oneofKind: "sessionStartedEvent",
                        sessionStartedEvent: SessionStartedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sessionStartedEvent)
                    };
                    break;
                case /* agency.events.v1.SessionEndedEvent session_ended_event */ 86:
                    message.payload = {
                        oneofKind: "sessionEndedEvent",
                        sessionEndedEvent: SessionEndedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sessionEndedEvent)
                    };
                    break;
                case /* agency.events.v1.ModelCircuitBreakerStateChange model_circuit_breaker_state_change */ 87:
                    message.payload = {
                        oneofKind: "modelCircuitBreakerStateChange",
                        modelCircuitBreakerStateChange: ModelCircuitBreakerStateChange.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).modelCircuitBreakerStateChange)
                    };
                    break;
                case /* agency.events.v1.ActorSpawnFailedEvent actor_spawn_failed_event */ 88:
                    message.payload = {
                        oneofKind: "actorSpawnFailedEvent",
                        actorSpawnFailedEvent: ActorSpawnFailedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).actorSpawnFailedEvent)
                    };
                    break;
                case /* agency.events.v1.SessionForkedEvent session_forked_event */ 89:
                    message.payload = {
                        oneofKind: "sessionForkedEvent",
                        sessionForkedEvent: SessionForkedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sessionForkedEvent)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnvelopeUnwrapResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.envelope.v1.EnvelopeValidationResult validation_result = 1; */
        if (message.validationResult)
            EnvelopeValidationResult.internalBinaryWrite(message.validationResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.PlanEvent plan_event = 10; */
        if (message.payload.oneofKind === "planEvent")
            PlanEvent.internalBinaryWrite(message.payload.planEvent, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.StepEvent step_event = 11; */
        if (message.payload.oneofKind === "stepEvent")
            StepEvent.internalBinaryWrite(message.payload.stepEvent, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.AgentDoneEvent agent_done_event = 12; */
        if (message.payload.oneofKind === "agentDoneEvent")
            AgentDoneEvent.internalBinaryWrite(message.payload.agentDoneEvent, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SessionFailedEvent session_failed_event = 13; */
        if (message.payload.oneofKind === "sessionFailedEvent")
            SessionFailedEvent.internalBinaryWrite(message.payload.sessionFailedEvent, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SessionStartFailedEvent session_start_failed_event = 14; */
        if (message.payload.oneofKind === "sessionStartFailedEvent")
            SessionStartFailedEvent.internalBinaryWrite(message.payload.sessionStartFailedEvent, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.CancelledEvent cancelled_event = 15; */
        if (message.payload.oneofKind === "cancelledEvent")
            CancelledEvent.internalBinaryWrite(message.payload.cancelledEvent, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.InterruptEvent interrupt_event = 16; */
        if (message.payload.oneofKind === "interruptEvent")
            InterruptEvent.internalBinaryWrite(message.payload.interruptEvent, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.TurnStart turn_start = 20; */
        if (message.payload.oneofKind === "turnStart")
            TurnStart.internalBinaryWrite(message.payload.turnStart, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.TurnEnd turn_end = 21; */
        if (message.payload.oneofKind === "turnEnd")
            TurnEnd.internalBinaryWrite(message.payload.turnEnd, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.MessageStart message_start = 22; */
        if (message.payload.oneofKind === "messageStart")
            MessageStart.internalBinaryWrite(message.payload.messageStart, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.MessageUpdate message_update = 23; */
        if (message.payload.oneofKind === "messageUpdate")
            MessageUpdate.internalBinaryWrite(message.payload.messageUpdate, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.AssistantMessageDelta assistant_message_delta = 24; */
        if (message.payload.oneofKind === "assistantMessageDelta")
            AssistantMessageDelta.internalBinaryWrite(message.payload.assistantMessageDelta, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.MessageEnd message_end = 25; */
        if (message.payload.oneofKind === "messageEnd")
            MessageEnd.internalBinaryWrite(message.payload.messageEnd, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ToolExecutionStart tool_execution_start = 30; */
        if (message.payload.oneofKind === "toolExecutionStart")
            ToolExecutionStart.internalBinaryWrite(message.payload.toolExecutionStart, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ToolExecutionUpdate tool_execution_update = 31; */
        if (message.payload.oneofKind === "toolExecutionUpdate")
            ToolExecutionUpdate.internalBinaryWrite(message.payload.toolExecutionUpdate, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ToolExecutionEnd tool_execution_end = 32; */
        if (message.payload.oneofKind === "toolExecutionEnd")
            ToolExecutionEnd.internalBinaryWrite(message.payload.toolExecutionEnd, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* agency.tool.v1.ToolCall tool_call = 33; */
        if (message.payload.oneofKind === "toolCall")
            ToolCall.internalBinaryWrite(message.payload.toolCall, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* agency.tool.v1.ToolResult tool_result = 34; */
        if (message.payload.oneofKind === "toolResult")
            ToolResult.internalBinaryWrite(message.payload.toolResult, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ContextUpdated context_updated = 40; */
        if (message.payload.oneofKind === "contextUpdated")
            ContextUpdated.internalBinaryWrite(message.payload.contextUpdated, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ContextReady context_ready = 41; */
        if (message.payload.oneofKind === "contextReady")
            ContextReady.internalBinaryWrite(message.payload.contextReady, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ArtifactUpdated artifact_updated = 42; */
        if (message.payload.oneofKind === "artifactUpdated")
            ArtifactUpdated.internalBinaryWrite(message.payload.artifactUpdated, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ArtifactInvalidationEvent artifact_invalidation_event = 43; */
        if (message.payload.oneofKind === "artifactInvalidationEvent")
            ArtifactInvalidationEvent.internalBinaryWrite(message.payload.artifactInvalidationEvent, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ToolCallFrequencyExceededEvent tool_call_frequency_exceeded_event = 50; */
        if (message.payload.oneofKind === "toolCallFrequencyExceededEvent")
            ToolCallFrequencyExceededEvent.internalBinaryWrite(message.payload.toolCallFrequencyExceededEvent, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.RateLimitedEvent rate_limited_event = 51; */
        if (message.payload.oneofKind === "rateLimitedEvent")
            RateLimitedEvent.internalBinaryWrite(message.payload.rateLimitedEvent, writer.tag(51, WireType.LengthDelimited).fork(), options).join();
        /* agency.quota.v1.QuotaExhaustedEvent quota_exhausted_event = 52; */
        if (message.payload.oneofKind === "quotaExhaustedEvent")
            QuotaExhaustedEvent.internalBinaryWrite(message.payload.quotaExhaustedEvent, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.HarnessReadyEvent harness_ready_event = 60; */
        if (message.payload.oneofKind === "harnessReadyEvent")
            HarnessReadyEvent.internalBinaryWrite(message.payload.harnessReadyEvent, writer.tag(60, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.HarnessShutdownEvent harness_shutdown_event = 61; */
        if (message.payload.oneofKind === "harnessShutdownEvent")
            HarnessShutdownEvent.internalBinaryWrite(message.payload.harnessShutdownEvent, writer.tag(61, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ToolRejectionEvent tool_rejection_event = 70; */
        if (message.payload.oneofKind === "toolRejectionEvent")
            ToolRejectionEvent.internalBinaryWrite(message.payload.toolRejectionEvent, writer.tag(70, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.RequestFailedEvent request_failed_event = 71; */
        if (message.payload.oneofKind === "requestFailedEvent")
            RequestFailedEvent.internalBinaryWrite(message.payload.requestFailedEvent, writer.tag(71, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ModelFallbackEvent model_fallback_event = 72; */
        if (message.payload.oneofKind === "modelFallbackEvent")
            ModelFallbackEvent.internalBinaryWrite(message.payload.modelFallbackEvent, writer.tag(72, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.DLQAlertEvent dlq_alert_event = 73; */
        if (message.payload.oneofKind === "dlqAlertEvent")
            DLQAlertEvent.internalBinaryWrite(message.payload.dlqAlertEvent, writer.tag(73, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SkillExecutionEvent skill_execution_event = 80; */
        if (message.payload.oneofKind === "skillExecutionEvent")
            SkillExecutionEvent.internalBinaryWrite(message.payload.skillExecutionEvent, writer.tag(80, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SnapshotEvent snapshot_event = 81; */
        if (message.payload.oneofKind === "snapshotEvent")
            SnapshotEvent.internalBinaryWrite(message.payload.snapshotEvent, writer.tag(81, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.TenantContextEvent tenant_context_event = 82; */
        if (message.payload.oneofKind === "tenantContextEvent")
            TenantContextEvent.internalBinaryWrite(message.payload.tenantContextEvent, writer.tag(82, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.LLMCallStart llm_call_start = 83; */
        if (message.payload.oneofKind === "llmCallStart")
            LLMCallStart.internalBinaryWrite(message.payload.llmCallStart, writer.tag(83, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.LLMCallEnd llm_call_end = 84; */
        if (message.payload.oneofKind === "llmCallEnd")
            LLMCallEnd.internalBinaryWrite(message.payload.llmCallEnd, writer.tag(84, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SessionStartedEvent session_started_event = 85; */
        if (message.payload.oneofKind === "sessionStartedEvent")
            SessionStartedEvent.internalBinaryWrite(message.payload.sessionStartedEvent, writer.tag(85, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SessionEndedEvent session_ended_event = 86; */
        if (message.payload.oneofKind === "sessionEndedEvent")
            SessionEndedEvent.internalBinaryWrite(message.payload.sessionEndedEvent, writer.tag(86, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ModelCircuitBreakerStateChange model_circuit_breaker_state_change = 87; */
        if (message.payload.oneofKind === "modelCircuitBreakerStateChange")
            ModelCircuitBreakerStateChange.internalBinaryWrite(message.payload.modelCircuitBreakerStateChange, writer.tag(87, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.ActorSpawnFailedEvent actor_spawn_failed_event = 88; */
        if (message.payload.oneofKind === "actorSpawnFailedEvent")
            ActorSpawnFailedEvent.internalBinaryWrite(message.payload.actorSpawnFailedEvent, writer.tag(88, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SessionForkedEvent session_forked_event = 89; */
        if (message.payload.oneofKind === "sessionForkedEvent")
            SessionForkedEvent.internalBinaryWrite(message.payload.sessionForkedEvent, writer.tag(89, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.envelope.v1.EnvelopeUnwrapResponse
 */
export const EnvelopeUnwrapResponse = new EnvelopeUnwrapResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnvelopeValidationResult$Type extends MessageType<EnvelopeValidationResult> {
    constructor() {
        super("agency.envelope.v1.EnvelopeValidationResult", [
            { no: 1, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 3, name: "validation_stage", kind: "enum", T: () => ["agency.envelope.v1.ValidationStage", ValidationStage, "VALIDATION_STAGE_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 4, name: "claims", kind: "message", T: () => Claims },
            { no: 5, name: "validated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<EnvelopeValidationResult>): EnvelopeValidationResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.valid = false;
        message.errorMessage = "";
        message.validationStage = 0;
        if (value !== undefined)
            reflectionMergePartial<EnvelopeValidationResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnvelopeValidationResult): EnvelopeValidationResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool valid */ 1:
                    message.valid = reader.bool();
                    break;
                case /* string error_message */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* agency.envelope.v1.ValidationStage validation_stage */ 3:
                    message.validationStage = reader.int32();
                    break;
                case /* agency.auth.v1.Claims claims */ 4:
                    message.claims = Claims.internalBinaryRead(reader, reader.uint32(), options, message.claims);
                    break;
                case /* google.protobuf.Timestamp validated_at */ 5:
                    message.validatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.validatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnvelopeValidationResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool valid = 1; */
        if (message.valid !== false)
            writer.tag(1, WireType.Varint).bool(message.valid);
        /* string error_message = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* agency.envelope.v1.ValidationStage validation_stage = 3; */
        if (message.validationStage !== 0)
            writer.tag(3, WireType.Varint).int32(message.validationStage);
        /* agency.auth.v1.Claims claims = 4; */
        if (message.claims)
            Claims.internalBinaryWrite(message.claims, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp validated_at = 5; */
        if (message.validatedAt)
            Timestamp.internalBinaryWrite(message.validatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.envelope.v1.EnvelopeValidationResult
 */
export const EnvelopeValidationResult = new EnvelopeValidationResult$Type();
